
export const VIOLET_ON_WHITE = 'DEFAULT';
export const WHITE_ON_BLACK = 'WHITE_ON_BLACK';
